import { Platform } from "react-native"

const isUnderSDK24 = Platform.OS === "android" && Platform.Version < 24

export default isUnderSDK24
